import Component from '../core/Component'
import enquire from 'enquire.js'
import throttle from 'lodash/throttle'
import { queries } from '../core/config'

const VISIBLE_ALL = 'is-visibleAll'

export default class NavCollapse extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }

        this.attach = ::this.attach

        this.enquireHandler = {
            match: this.attach,
        }
    }

    prepare() {
        enquire.register(queries.largeUp, this.enquireHandler)
        window.addEventListener('resize', this.throttledRefresh)
    }

    destroy() {
        enquire.unregister(queries.largeUp, this.enquireHandler)
        window.removeEventListener('resize', this.throttledRefresh)
    }

    attach() {
        this.element.classList.toggle(VISIBLE_ALL)
    }
    
}